import { graphql, useStaticQuery } from "gatsby"

const useSchemaSettings = () => {
  const data = useStaticQuery(graphql`
    query SchemaSettings {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
	      allWp {
	        nodes {
	          schemaSettings {
	            acfSchemaSettings {
	              companyName
	              companyDescription
	              logo {
	                altText
	                mediaItemUrl
	                sourceUrl
	                localFile {
	                  publicURL
	                  childImageSharp {
	                    gatsbyImageData(layout: FULL_WIDTH, placeholder: DOMINANT_COLOR)
	                  }
	                }
	              }
              socialLinks {
                label
                url
              }
              contactEmail
              address {
                streetAddress
                addressLocality
                postalCode
                addressCountry
              }
              foundingDate
              numberOfEmployees
              websiteName
              websiteUrl
            }
          }
        }
      }
    }
  `)

  return {
    siteUrl: data.site?.siteMetadata?.siteUrl,
    siteMetadata: data.site?.siteMetadata || {},
    settings: data.allWp?.nodes?.[0]?.schemaSettings?.acfSchemaSettings || {},
  }
}

export default useSchemaSettings
